import { src as currentScriptSrc } from '../../utils/current-script';
import { CUSTOM_STYLES_ID } from '@sitegen/common/constants/styles';
import * as URI from 'urijs';

export interface ICreateLinkElement {
    readonly url: string;
    readonly id?: string;
}

export const createLinkElement = ({ url, id }: ICreateLinkElement): HTMLLinkElement => {
    const linkElement = document.createElement('link');
    linkElement.setAttribute('href', url);
    linkElement.setAttribute('type', 'text/css');
    linkElement.setAttribute('rel', 'stylesheet');
    if (id) {
        linkElement.setAttribute('id', id);
    }
    return linkElement;
};

export const createDefaultStyleFileName = (chunkName: string): string => `${chunkName}-root-index.css`;

export const CURRENT_LOCATION: string | null = currentScriptSrc ? currentScriptSrc.substring(0, currentScriptSrc.lastIndexOf('/')) : null;

export const ASSET_MANIFEST_URL: string = new URI(CURRENT_LOCATION || '').segment('asset-manifest.json').href();

export const customCSSSelector = `link[href*="custom."][href*=".css"], #${CUSTOM_STYLES_ID}`;
